import { render, staticRenderFns } from "./offlinehealthmanagement.vue?vue&type=template&id=70254910&"
import script from "./offlinehealthmanagement.vue?vue&type=script&lang=js&"
export * from "./offlinehealthmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports